import { render, staticRenderFns } from "./CardManagement.vue?vue&type=template&id=6b35b594&scoped=true&"
import script from "./CardManagement.vue?vue&type=script&lang=js&"
export * from "./CardManagement.vue?vue&type=script&lang=js&"
import style0 from "./CardManagement.vue?vue&type=style&index=0&id=6b35b594&prod&lang=scss&"
import style1 from "./CardManagement.vue?vue&type=style&index=1&id=6b35b594&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b35b594",
  null
  
)

export default component.exports